import { purple } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { Button } from "../../globalStyles";

export const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#34935a",
    "&:hover": {
        backgroundColor: "#42b972",
    },
}));
